import React, { useState } from 'react'
import './callingInfrastructureForPreSale.css'
import cloud_telephone from 'assets/infrastructureCalls/cloud_telephone.png'
import vanity_numbers from 'assets/infrastructureCalls/vanity_numbers.png'
import phone_verify from 'assets/infrastructureCalls/phone_verify.png'
import mail_call from 'assets/infrastructureCalls/mail_call.png'
import intelligent_call from 'assets/infrastructureCalls/intelligent_call.png'
import maintain_continuity from 'assets/infrastructureCalls/maintain_continuity.png'
import conference_call from 'assets/infrastructureCalls/conference_call.png'
import disposition from 'assets/infrastructureCalls/disposition.png'
import calling_dashboard from 'assets/infrastructureCalls/calling_dashboard.png'
import progress_call from 'assets/infrastructureCalls/progress_call.png'
import click_call from 'assets/infrastructureCalls/click_call.png'
import call_recording from 'assets/infrastructureCalls/call_recording.png'
import { useNavigate } from "react-router-dom";

const CallingInfrastructureForPreSale = () => {
  const navigate = useNavigate();
  const [visibleDescriptions, setVisibleDescriptions] = useState(null);

  const handleGetDemo = (e) => {
    e.preventDefault();
    navigate("../request-a-demo");
  };

  const headings = [
    "What is Lead Management in Real Estate?",
    "What is Real Estate Lead Management CRM Software?",
    "How can Real Estate Lead Management CRM streamline lead generation processes?",
    "How can Realtor Desk's Lead Management CRM feature help?"
  ];
  
  const descriptions = [
    "Lead Management in Real Estate refers to organizing and tracking potential customers (leads) throughout the sales process. It helps sales representatives keep all the information in one place, making it easier to convert leads into clients.",
    "Real Estate Lead Management CRM software is a tool designed to automate and simplify the process of handling potential customers (leads) in the real estate industry. It works by capturing leads from various sources, preventing duplication of data, and providing a complete overview of each lead. ",
    "In Real Estate Lead Management CRM, getting leads becomes simpler. It collects them from different places automatically, avoids repeating the data, and helps give a full view of each lead. In addition to this, it has features like lead scoring. This makes it easier to keep everything organized and understand lead intentions better.",
    "Realtor Desk's Lead Management CRM makes things easier for real estate professionals. It automatically collects leads and ensures security with OTP verification. You get an overview of each lead and useful tools like lead scoring, appointment scheduling, tasks, and personalized sales pipelines. This simplifies the whole lead management process, making it more efficient for real estate professionals."
  ];

  const showDescription = (index) => {
    setVisibleDescriptions((prevIndex) => (prevIndex === index ? null : index));
  };
  

  return (
      <div className="calling-container">
        <div className="calling-top-heading">
          <h1>
            Get State-of-the-art calling infrastructure for pre-sales. For free.
          </h1>
          <p>
            Realtor Desk comes with build-in cloud telephony services that improve performance
          </p>
          <button onClick={handleGetDemo} className='calling-btn'>GET A DEMO</button>
        </div>
        <div className="calling-content-container">
          <div className="calling-heading">
            <h1>Better pre-sales calling with Realtor Desk real estate CRM</h1>
            <p>It will never happen in real estate that a lead is converted just through marketing efforts. Human intervention is a must. Realtor Desk's CRM call center empowers you with cutting0edge infrastructure for real time monitoring software, so you get better numbers at the first touch point if your sales cycle. And the best part, you don't have to pay a single extra Rupee for it!</p>
          </div>
          <div className="calling-content-row row">
            <div className="col-12 calling-col">
              <div className="col-md-6 calling-content-left">
                <button>Phone Number- India & International</button>
                <h1>Reach leads wherever they are</h1>
                <p>
                  Investors and buyer come in from around the world - indian and international telephony numbers ensure that geographic location is not a constraint.
                </p>
              </div>
              <div className="col-md-6 calling-image-right">
                <img src={phone_verify} alt="" />
              </div>
            </div>
          </div>
          <div className="calling-content-row row">
            <div className="col-12 calling-col">
              <div className="col-md-6 calling-image-left">
                <img src={cloud_telephone} alt="" />
              </div>
              <div className="col-md-6 calling-content-right">
                <button>On-premise & Cloud Telephony Support</button>
                <h1>The complete call center experience, on the go</h1>
                <p>
                  With cloud telephony, you can rest assured that your team is working well remotely - sales persons get all the call center features on their mobiles, while you get all the recording and data. Don't worry if you have already invested in an on-permise set up; we have you covered, We offer a CRM call center which supports both on-permise & cloud telephony!.
                </p>
              </div>
            </div>
          </div>
          <div className="calling-content-row row">
            <div className="col-12 calling-col">
              <div className="col-md-6 calling-content-left">
                <button>Vanity Numbers</button>
                <h1>Use virtual numbers to back leads across mediums</h1>
                <p>
                  An extensive base of virtual numbers makes it easy for you to automatically track leads from serval campaigns and mediums at a time.
                </p>
              </div>
              <div className="col-md-6 calling-image-right">
                <img src={vanity_numbers} alt="" />
              </div>
            </div>
          </div>
          <div className="calling-content-row row">
            <div className="col-12 calling-col">
              <div className="col-md-6 calling-image-left">
                <img src={mail_call} alt="" />
              </div>
              <div className="col-md-6 calling-content-right">
                <button>Built-in Voicemail, IVR & Greetings</button>
                <h1>Streamline incoming calls</h1>
                <p>
                  Built-in voicemail, IVR and greetings create a smooth leads experience while reducing turnaround time and improving productivity for your team.
                </p>
              </div>
            </div>
          </div>
          <div className="calling-content-row row">
            <div className="col-12 calling-col">
              <div className="col-md-6 calling-content-left">
                <button>Intelligent Call Routing</button>
                <h1>Automated lead distribution</h1>
                <p>
                  Intelligent call routing allows you to automatically distribute incoming leads, either in a round robin pattern or according to pre-define rules. You can choose to distribute leads to sales persons based on their location, product, expertise, hierarchy or department.
                </p>
              </div>
              <div className="col-md-6 calling-image-right">
                <img src={intelligent_call} alt="" />
              </div>
            </div>
          </div>
          <div className="calling-content-row row">
            <div className="col-12 calling-col">
              <div className="col-md-6 calling-image-left">
                <img src={maintain_continuity} alt="" />
              </div>
              <div className="col-md-6 calling-content-right">
                <button>Call Barging & Conference Calls</button>
                <h1>Manage the quality of your sales calls</h1>
                <p>
                  Sales managers can "Barge in" on on-going sales call for quality control and can also be invited by the sales person into a conference call to share their expertise.
                </p>
              </div>
            </div>
          </div>
          <div className="calling-content-row row">
            <div className="col-12 calling-col">
              <div className="col-md-6 calling-content-left">
                <button>Intelligent Call Routing</button>
                <h1>Automated lead distribution</h1>
                <p>
                  Intelligent call routing allows you to automatically distribute incoming leads, either in a round robin pattern or according to pre-define rules. You can choose to distribute leads to sales persons based on their location, product, expertise, hierarchy or department.
                </p>
              </div>
              <div className="col-md-6 calling-image-right">
                <img src={conference_call} alt="" />
              </div>
            </div>
          </div>
          <div className="calling-content-row row">
            <div className="col-12 calling-col">
              <div className="col-md-6 calling-image-left">
                <img src={disposition} alt="" />
              </div>
              <div className="col-md-6 calling-content-right">
                <button>Dispositions & Breaks</button>
                <h1>Keep Track of call dispositions & breaks</h1>
                <p>
                  Maintain full control on call dispositions and when your team is taking breaks, to optimize productivity and effectiveness. You can also get in-depth insights with forced call dispositions and call outcome reports.
                </p>
              </div>
            </div>
          </div>
          <div className="calling-content-row row">
            <div className="col-12 calling-col">
              <div className="col-md-6 calling-content-left">
                <button>Real Time Monitoring & Dashboard</button>
                <h1>Keep a check on performance & productivity</h1>
                <p>
                  Your real time dashboard provides insights into daily calling performance, lead progress and more. You can also set up expected performance vs achieved performance benchmarks to help your pre-sales executives self-monitor and stay on top of their game.
                </p>
              </div>
              <div className="col-md-6 calling-image-right">
                <img src={calling_dashboard} alt="" />
              </div>
            </div>
          </div>
          <div className="calling-content-row row">
            <div className="col-12 calling-col">
              <div className="col-md-6 calling-image-left">
                <img src={progress_call} alt="" />
              </div>
              <div className="col-md-6 calling-content-right">
                <button>Call Related Intelligence On Leads</button>
                <h1>Get insights on lead quality & progress from calls</h1>
                <p>
                  Realtor Desk helps you understand how your sales calls are going - is the lead answering them, what's the duration, are getting a follow-up call, all of this ties into an intelligent lead score that allow you & your team to focus oon quality, engaged leads.
                </p>
              </div>
            </div>
          </div>
          <div className="calling-content-row row">
            <div className="col-12 calling-col">
              <div className="col-md-6 calling-content-left">
                <button>Click to Call</button>
                <h1>Save on time with click-to-call</h1>
                <p>
                  The easy click-to-call feature allows your sales teams to place calls from within the system, saving them valuable time and eliminating the likelihood of procrastination.
                </p>
              </div>
              <div className="col-md-6 calling-image-right">
                <img src={click_call} alt="" />
              </div>
            </div>
          </div>
          <div className="calling-content-row row">
            <div className="col-12 calling-col">
              <div className="col-md-6 calling-image-left">
                <img src={click_call} alt="" />
              </div>
              <div className="col-md-6 calling-content-right">
                <button>Manual Call Logs</button>
                <h1>Plug manual calls back into the system</h1>
                <p>
                  Aren't planning on using cloud telephony? Or what if a sales person makes a call from a personal phone? We've got it covered - they can manually log the call in the system, helping you understand customers interactions & build a score, as well as trigger your nurturing flows.
                </p>
              </div>
            </div>
          </div>
          <div className="calling-content-row row">
            <div className="col-12 calling-col">
              <div className="col-md-6 calling-content-left">
                <button>Always Available Call Recording</button>
                <h1>Keep track of quality and leads with call recording</h1>
                <p>
                  Always available call recording allow sales managers to keep track of quality and analyze and gaps that be arising during prospecting.
                </p>
              </div>
              <div className="col-md-6 calling-image-right">
                <img src={call_recording} alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="calling-faq-row">
          {headings.map((heading, index) => (
            <div key={index}>
              <div  className={`calling-col-heading ${visibleDescriptions === index ? 'active' : ''}`} onClick={() => showDescription(index)}>
                <h1>{heading}</h1>
                <i className={`fa-solid fa-arrow-${visibleDescriptions === index ? 'up' : 'down'}`}></i>
              </div>
              <div className="calling-desc" style={{ display: visibleDescriptions === index ? 'block' : 'none' }}>
                <p>{descriptions[index]}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
  )
}

export default CallingInfrastructureForPreSale
